import React, { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { createPrivilege, deletePrivilege, fetchAllPrivilege, updatePrivilege } from "../../../resources/PrivilegeResource";
import { showSuccessToast } from "../../../utils/GlobalToast";
import { format } from "date-fns";
import ErrorNotFound from "../../errors/Error";
import { getLocalAuth } from "../../../utils/AuthUtils";

function Privilege() {
  const values = getLocalAuth()
  const privilege = JSON.parse(values.authPrivilege);

  let dataPrivilegeDetail = privilege.data.menu.filter(data => {
    return data.code === "Privilege"
  });

  let dataRead = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Read"
  });

  let dataCreate = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Create"
  });

  let dataUpdate = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Update"
  });

  let dataDelete = dataPrivilegeDetail.length === 0 ? [] : dataPrivilegeDetail[0].action_page.filter(data => {
    return data.code === "Delete"
  });

  const [dataPrivilege, setPrivilege] = useState([]);
  const [name, setName] = useState("");
  const [idEdit, setIdEdit] = useState(null);
  const [nameEdit, setNameEdit] = useState("");
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState("");
  const [isErrorDelete, setIsErrorDelete] = useState(false);
  const [errorDelete, setErrorDelete] = useState("");
  const [isErrorEdit, setIsErrorEdit] = useState(false);
  const [errorEdit, setErrorEdit] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const fetchPrivilege = () => {
    fetchAllPrivilege()
      .then((res) => {
        setPrivilege(res.data);
      })
      .catch((err) => {
        setPrivilege([]);
      });
  };

  useEffect(() => {
    fetchPrivilege();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    postPrivilege(name);
  }

  const postPrivilege = (name) => {
    setIsLoading(true);
    createPrivilege(name).then((res) => {
      setIsLoading(false);
      setIsError(false);
      showSuccessToast("Success Added Privilege!");
      setShowAddModal(false);
      setName("");
      fetchPrivilege();
    }).catch((err) => {
      setIsLoading(false);
      setError(typeof err === 'undefined' ? 'There was an error checking your connection or input' : err);
      setIsError(true);
    });
  }

  const handleData = (data) => {
    setIdEdit(data.id);
    setNameEdit(data.name);
  }

  const handleDelete = () => {
    setIsLoading(true);
    deletePrivilege(idEdit).then((res) => {
      setIsLoading(false);
      setIsErrorDelete(false);
      showSuccessToast("Success Deleted Privilege!");
      setShowDeleteModal(false);
      fetchPrivilege();
    }).catch((err) => {
      setIsLoading(false);
      setErrorDelete(err);
      setIsErrorDelete(true);
    });
  }

  const handleEdit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    updatePrivilege(idEdit, nameEdit).then((res) => {
      setIsLoading(false);
      setIsErrorEdit(false);
      showSuccessToast("Success Updated Privilege!");
      setShowEditModal(false);
      fetchPrivilege();
    }).catch((err) => {
      setIsLoading(false);
      setErrorEdit(err);
      setIsErrorEdit(true);
    });
  }

  const columns = [
    {
      name: 'No',
      cell: (row, index) => index + 1,
      width: '60px'
    },
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Created At',
      selector: row => row.created_at === null ? '-' : format(row.created_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: 'Updated At',
      selector: row => row.updated_at === null ? '-' : format(row.updated_at, "yyyy-MM-dd HH:mm").toString(),
      sortable: true,
    },
    {
      name: 'Actions',
      cell: row => (
        <>
          {dataDelete.length === 0 ? <div></div> : !dataDelete[0].is_active ? <div></div> : <button type="button" style={{ marginRight: "8px" }} className="btn btn-danger" onClick={() => {
            handleData(row);
            setShowDeleteModal(true);
          }}>Delete</button>}
          <div className={`modal fade ${showDeleteModal ? 'show' : ''}`} style={{ display: showDeleteModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Delete this data?</h5>
                  <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)} aria-label="Close"></button>
                </div>
                {isErrorDelete ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorDelete}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorDelete(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  {`You will delete ${nameEdit}`}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                  {!isLoading ? <button type="submit" className="btn btn-danger" onClick={() => handleDelete()}>Delete</button> :
                    <button className="btn btn-danger" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Loading...</button>}
                </div>
              </div>
            </div>
          </div>
          {dataUpdate.length === 0 ? <div></div> : !dataUpdate[0].is_active ? <div></div> : <button type="button" className="btn btn-info" onClick={() => {
            handleData(row);
            setShowEditModal(true);
          }}>View</button>}
          <div className={`modal fade ${showEditModal ? 'show' : ''}`} style={{ display: showEditModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.1)' }}>
            <div className="modal-dialog modal-dialog-scrollable">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Master Data Privilege</h5>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)} aria-label="Close"></button>
                </div>
                {isErrorEdit ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                  <div className="alert alert-danger alert-dismissible fade show" role="alert">{errorEdit}
                    <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsErrorEdit(false)}></button>
                  </div>
                </div> : null}
                <div className="modal-body">
                  <form onSubmit={handleEdit}>
                    <div className="mb-3">
                      <label className="form-label fw-bold">Name</label>
                      <input required type="text" className="form-control" value={nameEdit} onChange={(e) => setNameEdit(e.target.value)} />
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>Cancel</button>
                      {!isLoading ? <button type="submit" className="btn btn-info">Save</button> :
                        <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                          Loading...</button>}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      {dataRead.length === 0 ? <ErrorNotFound /> : !dataRead[0].is_active ? <ErrorNotFound /> :
        <div className="page-content-wrapper">
          <div className="page-content">
            <div className="card">
              <div className="card-body">
                <div className="card-title">
                  <div className="row">
                    <div className="col-md-10">
                      <h4 className="mb-0">Master Data Privilege</h4>
                    </div>
                    <div className="col-md-2 text-end d-grid">
                      {dataCreate.length === 0 ? <div></div> : !dataCreate[0].is_active ? <div></div> : <button type="button" className="btn btn-info ms-auto radius-10" onClick={() => {
                        setShowAddModal(true);
                      }}><i className='bx bx-plus'></i> Privilege</button>}
                    </div>
                    <div className={`modal fade ${showAddModal ? 'show' : ''}`} style={{ display: showAddModal ? 'block' : 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
                      <div className="modal-dialog modal-dialog-scrollable">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Master Data Privilege</h5>
                            <button type="button" className="btn-close" onClick={() => {
                              setShowAddModal(false);
                            }} aria-label="Close"></button>
                          </div>
                          {isError ? <div style={{ paddingLeft: '16px', paddingRight: '16px', paddingTop: '16px', paddingBottom: '0px' }}>
                            <div className="alert alert-danger alert-dismissible fade show" role="alert">{error}
                              <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() => setIsError(false)}></button>
                            </div>
                          </div> : null}
                          <div className="modal-body">
                            <form onSubmit={handleSubmit}>
                              <div className="mb-3">
                                <label className="form-label fw-bold">Name</label>
                                <input required type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
                              </div>
                              <br></br>
                              <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => {
                                  setShowAddModal(false);
                                }}>Cancel</button>
                                {!isLoading ? <button type="submit" className="btn btn-info">Submit</button> :
                                  <button className="btn btn-info" type="button" disabled> <span style={{ marginRight: '4px' }} className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Loading...</button>}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="table-responsive">
                  <DataTable
                    columns={columns}
                    data={dataPrivilege}
                    pagination
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default Privilege